// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoriesSection_wrapper__Paa8V {
  text-align: left;
}

.CategoriesSection_title__QuXbU {
  font-size: 20px;
  font-weight: 600;
  color: #222;
  margin-bottom: 20px;
}

.CategoriesSection_card__5G9d9 {
  width: 320px;
  background-color: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.05);
}

.CategoriesSection_cardHeader__d1SxE {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.CategoriesSection_cardTitle__IDM5B {
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.CategoriesSection_addButton__3djgk {
  background-color: rgba(29, 135, 82, 1);
  border: none;
  color: white;
  font-size: 20px;
  padding: 3px 13px;
  border-radius: 6px;
  cursor: pointer;
}

.CategoriesSection_emptyState__ite14 {
  margin-top: 40px;
  text-align: center;
}

.CategoriesSection_emptyTitle__i-haw {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.CategoriesSection_emptyText__oJaza {
  color: #a1a1a1;
  font-size: 14px;
  margin-bottom: 20px;
}

.CategoriesSection_categoryItem__ngw4J {
  display: flex;
  align-items: center;
  padding: 1rem;
}

.CategoriesSection_dragIcon__rTfgn {
  font-size: 30px;
  color: black;
  margin-left: -20px;
  margin-right: 20px;
}

.CategoriesSection_arrowIcon__YXNxV {
  margin-left: auto;
}

.CategoriesSection_actions__a2ETs {
  display: flex;
  justify-content: space-evenly;
}

.CategoriesSection_delete__ZvG6v {
  color: red;
}

.CategoriesSection_save__97iH4 {
  color: rgba(29, 135, 82, 1);
}`, "",{"version":3,"sources":["webpack://./src/pages/tablesStyle/CategoriesSection.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".wrapper {\n  text-align: left;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #222;\n  margin-bottom: 20px;\n}\n\n.card {\n  width: 320px;\n  background-color: #fff;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.05);\n}\n\n.cardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cardTitle {\n  font-size: 16px;\n  font-weight: 600;\n  color: #000;\n}\n\n.addButton {\n  background-color: rgba(29, 135, 82, 1);\n  border: none;\n  color: white;\n  font-size: 20px;\n  padding: 3px 13px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.emptyState {\n  margin-top: 40px;\n  text-align: center;\n}\n\n.emptyTitle {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin-bottom: 8px;\n}\n\n.emptyText {\n  color: #a1a1a1;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.categoryItem {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n}\n\n.dragIcon {\n  font-size: 30px;\n  color: black;\n  margin-left: -20px;\n  margin-right: 20px;\n}\n\n.arrowIcon {\n  margin-left: auto;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.delete {\n  color: red;\n}\n\n.save {\n  color: rgba(29, 135, 82, 1);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CategoriesSection_wrapper__Paa8V`,
	"title": `CategoriesSection_title__QuXbU`,
	"card": `CategoriesSection_card__5G9d9`,
	"cardHeader": `CategoriesSection_cardHeader__d1SxE`,
	"cardTitle": `CategoriesSection_cardTitle__IDM5B`,
	"addButton": `CategoriesSection_addButton__3djgk`,
	"emptyState": `CategoriesSection_emptyState__ite14`,
	"emptyTitle": `CategoriesSection_emptyTitle__i-haw`,
	"emptyText": `CategoriesSection_emptyText__oJaza`,
	"categoryItem": `CategoriesSection_categoryItem__ngw4J`,
	"dragIcon": `CategoriesSection_dragIcon__rTfgn`,
	"arrowIcon": `CategoriesSection_arrowIcon__YXNxV`,
	"actions": `CategoriesSection_actions__a2ETs`,
	"delete": `CategoriesSection_delete__ZvG6v`,
	"save": `CategoriesSection_save__97iH4`
};
export default ___CSS_LOADER_EXPORT___;
